module.exports = "<div class=\"c-edit-reservation\" ng-if=\"$ctrl.isEditing()\">\n    <button class=\"c-loginout__action / t-text--secondary--action\" ng-click=\"$ctrl.stopEditing()\">Logout</button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/stopEditing.html
// module id = 795
// module chunks = 0